module.exports = __webpack_public_path__ + "img/Profile View - 1.9c60555b.svg";